export var cortinaColors = {
  '--GW-BACKGROUND-COLOR-BODY': '#f0f1f5'
};